module.exports = __webpack_public_path__ + "png/quick-registration-coin-6.png?52fdcb9a2ad5d66b6063eedb00e25b86";